module.exports = __webpack_public_path__ + "static/img/florent.montel.1299b4a7.jpg";